import {
    type AdminAgentTier,
    isAdminAgentTier,
} from '@apps/web/routes/_app/admin/agent/admin_agent_tier_picker';

const ADMIN_AGENT_TIER_LOCAL_STORAGE_KEY = 'phoebe.admin_agent.tier';

export function readStoredAdminAgentTier(): AdminAgentTier {
    if (typeof window === 'undefined') {
        return 'auto';
    }
    const storedTier = window.localStorage.getItem(
        ADMIN_AGENT_TIER_LOCAL_STORAGE_KEY,
    );
    return storedTier && isAdminAgentTier(storedTier) ? storedTier : 'auto';
}

export function writeStoredAdminAgentTier(tier: AdminAgentTier): void {
    if (typeof window === 'undefined') {
        return;
    }
    window.localStorage.setItem(ADMIN_AGENT_TIER_LOCAL_STORAGE_KEY, tier);
}
